import React, { useEffect } from 'react';
import './ContactPage.scss'
import '../../pages/styles.scss'
import FooterSection from '../../../components/reusable/HomePageSections/FooterSection/FooterSection.js';
import CommonInsuranceSection from '../../../components/reusable/HomePageSections/CommonInsuranceSection/CommonInsuranceSection.js';
import ContactForm from '../../../components/reusable/ContactForm/ContactForm.js';

const ContactPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);
    return (
        <div className='contact-page-container container'>
            <div className='form-wrapper'>
                <div className="contact-info">
                    <h2>Contact Us</h2>
                    <p>If you would like more information about Virginia Rehab Physicians’ programs, or you have any questions, please fill out the short form.</p>
                    <br />
                    <hr className="section-divider" />
                    <ul>
                        <li>📞 (804) 220-5770</li>
                        <li>📧  info@varehabphysicians.com</li>
                        <li>🏢 2420 Maplewood Ave, Ste G Richmond, VA 23220</li>
                        <li><strong>Mon - Fri:</strong> 09:00AM - 05:00PM</li>
                        <li><strong>Sat - Sun:</strong> Closed</li>
                    </ul>
                </div>
                <ContactForm className='custom-form-css' />
            </div>
            <CommonInsuranceSection />
            <FooterSection />
        </div>
    )
}

export default ContactPage
